import {useAtom} from 'jotai'

import store from '..'
import {
  CreateCompanyGroupService,
  GetCompanyGroupService,
  UpdateCompanyGroupService,
} from '../../service/company-group.service'
import {IPageOption} from '../../interface/paging/paging'

export const useCompanyGroupDispatch = () => {
  const [, dispatch] = useAtom(store)

  const setCompanyGroupLoading = (loading: boolean) => {
    dispatch({type: 'COMPANY_GROUP/SET_LOADING', payload: loading})
  }

  const getCompanyGroup = async (pageOption?: IPageOption) => {
    setCompanyGroupLoading(true)

    try {
      const getCompanyGroupService = new GetCompanyGroupService()
      const res = await getCompanyGroupService.request({page: 1, limit: 1, getAll: true})
      dispatch({type: 'COMPANY_GROUP/SET_DATA', payload: JSON.parse(JSON.stringify(res.data))})
      return res
    } catch (error) {
      dispatch({type: 'COMPANY_GROUP/SET_LOADING', payload: false})
    }

    setCompanyGroupLoading(false)
  }

  return {
    getCompanyGroup,
    setCompanyGroupLoading,
  }
}
